import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { GetBlog } from "./Components/Services";
import Loading from "../../Common/Loading";
import RandomBlogCardSidebar from "./Components/RandomBlogCardSidebar";
import RenderBasket from "../../Common/RenderBasket";
import { useSelector } from "react-redux";
import { webTemp } from "../../../Utils/styles";
import Mobile2 from "../../Common/Mobile2/index";
import Comments from "../../Common/Comments";
import BlogContent from "./Components/BlogContent";
import "../Item/index.css";
import BoxShadow from "../../../Panel/Common/Components/BoxShadow";
function Single({ isApp }) {
  const { slug } = useParams();
  const basket = useSelector(state => state.basket);
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    Handler();
  }, [slug]);
  const Handler = () => {
    setState({ ...state, loading: true });
    GetBlog(slug).then(result => {
      setState({
        loading: false,
        data: result,
      });
    });
  };

  const renderSlug = () => {
    let slugList = slug && slug.split("-");
    let res = "";
    slugList &&
      slugList.map(ch => {
        if (!(typeof ch == "number")) {
          res += " " + ch;
        }
      });
    return res;
  };
  const renderDesc = () => {
    if (!state.loading) {
      if (state.data.data.seo && state.data.data.seo.seoDescription) {
        return state.data.data.seo.seoDescription;
      } else {
        return renderSlug(slug);
      }
    }
  };

  const rendeKeyWords = () => {
    let res = "";
    if (!state.loading) {
      if (
        state.data.data.seo &&
        state.data.data.seo.seoKeyword &&
        Array.isArray(state.data.data.seo.seoKeyword)
      ) {
        state.data.data.seo.seoKeyword.map((key, count) => {
          if (state.data.data.seo.seoKeyword.length - 1 == count) {
            res = res + key;
          } else {
            res = res + key + ",";
          }
        });
        return res;
      } else {
        return renderSlug(slug);
      }
    }
  };
  const renderAlt = blog => {
    if (
      blog.images_alt &&
      Array.isArray(blog.images_alt) &&
      blog.images_alt[0]
    ) {
      return blog.images_alt[0];
    }
    return `${blog.title} مقاله`;
  };
  return (
    <>
      <Helmet>
        <title>
          {state.loading
            ? renderSlug(slug)
            : `${state.data.data.title} - نیکوتن`}{" "}
          | نیکوتن
        </title>
        <meta name="description" content={renderDesc()} />
        <meta name="robots" content="index, follow" />
        <meta name="keywords" content={rendeKeyWords()} />
        <link rel="canonical" href={window.origin + `/blogs/${slug}`} />

        {state?.data?.data?.seo.seoSchema &&
          <script type="application/ld+json">
            {state?.data?.data?.seo.seoSchema}
          </script>
        }

      </Helmet>
      <section className="blog-single-page"
        style={{ backgroundColor: !isApp && "#F6F6F6" }} >
        <div className="container">
          <div className="row flex-row-reverse">
            <div className=" col-lg-4 d-lg-block  d-none">
              <div className="importants mt-3" style={{ ...webTemp }}>
                {state.loading ? (
                  <Loading count={1} col={3} height={30} />
                ) : (
                  <header className="mb-3 mt-3 mt-xl-0 pb-0">
                    <h5 className="fw-bold h5 border-bottom pb-2.offer-area pb-2 ">
                      مقالات پربازدید
                    </h5>
                  </header>
                )}
                <div className="items d-flex flex-wrap flex-xl-column flex-row">
                  {state.loading ? (
                    <Loading count={3} margin={2} col={12} height={140} />
                  ) : (
                    state.data &&
                    state.data.random_blogs.map((item, key) => (
                      <RandomBlogCardSidebar key={key} data={item} />
                    ))
                  )}
                </div>
              </div>
              <div className="importants mt-3" style={{ ...webTemp }}>
                {state.loading ? (
                  <Loading count={1} col={3} height={30} />
                ) : (
                  <header className="mb-3 mt-3 mt-xl-0 pb-0">
                    <h5 className="fw-bold h5 border-bottom pb-2.offer-area pb-2 ">
                      آخرین مقالات
                    </h5>
                  </header>
                )}
                <div className="items d-flex flex-wrap flex-xl-column flex-row">
                  {state.loading ? (
                    <Loading count={3} margin={2} col={12} height={140} />
                  ) : (
                    state.data &&
                    state.data.offered_items.map((item, key) => (
                      <RandomBlogCardSidebar key={key} data={item} />
                    ))
                  )}
                </div>
              </div>
            </div>

            {state.loading ? (
              <Loading count={1} col={8} height={800} />
            ) : (
              <div className="col-lg-8">
                <div style={isApp ? { padding: "10px 0px", } : { ...webTemp }}>
                  <header className="pb-0 row mb-4">
                    <div className={"col-sm-8 text-start " + (isApp && "border-bottom mb-3 pb-2 mt-2")}>
                      <h5
                        style={{
                          fontWeight: "500",
                        }}
                        className={"mb-2 " + (isApp && "mb-3 nfs-18")}
                      >
                        {state && state.data.data.title}
                      </h5>
                      <p
                        style={{
                          color: "#B1B1B1",
                          fontWeight: "400",
                          textAlign: "justify",
                          fontSize: isApp ? "11px" : "13px",
                        }}
                      >
                        {state &&
                          state.data &&
                          state.data.data &&
                          state.data.data.description}
                      </p>
                    </div>
                    <div className="col-sm-4  d-flex flex-wrap justify-content-center justify-content-sm-end align-items-center">
                      <div className={isApp && "w-100 d-flex flex-wrap"}>
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            fontWeight: "400",
                            color: "#B1B1B1",
                            flex: isApp && "0 0 100%"
                          }}
                        >
                          <img
                            src={
                              window.origin + "/WebSide/assets/images/write.png"
                            }
                            style={{
                              width: "16px",
                              height: "16px",
                              marginLeft: "5px",
                            }}
                            alt="همه ملاقات"
                          />
                          {state.data.data && state.data.data.authtor.fullname}
                        </h6>
                        <h6
                          style={{
                            fontSize: "14px",
                            color: "#B1B1B1",
                            fontWeight: "400",
                            flex: isApp && "0 0 70%"
                          }}
                        >
                          <img
                            src={
                              window.origin + "/WebSide/assets/images/cat.png"
                            }
                            style={{
                              width: "16px",
                              height: "16px",
                              marginLeft: "5px",
                            }}
                            alt={
                              state.data &&
                              state.data.data.blog_category &&
                              state.data.data.blog_category.name
                            }
                          />
                          {state.data.data &&
                            state.data.data.blog_category &&
                            state.data.data.blog_category.name}
                        </h6>
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#B1B1B1",
                            flex: isApp && "0 0 30%",
                            textAlign: isApp && "left"
                          }}
                        >
                          <img
                            src={
                              window.origin + "/WebSide/assets/images/sen.png"
                            }
                            style={{
                              width: "16px",
                              height: "16px",
                              marginLeft: "5px",
                            }}
                            alt={"تعداد بازدید"}
                          />
                          {state.data.data && state.data.data.seens}
                        </h6>
                      </div>
                      {/* <a
                      href={`https://xn--r1a.link/share/url?url=${window.location.href}&text=${state.data.data.title}`}
                      className="d-inline-block"
                      style={{ lineHeight: "unset" }}
                      aria-label="telegram"
                    >
                      <i
                        className="fab fa-telegram mx-2"
                        style={{ fontSize: 25 }}
                      ></i>
                    </a>
                    <a
                      href={`https://wa.me/?text=${state.data.data.title}%0A%0A${window.location.href}`}
                      className="d-inline-block"
                      style={{ lineHeight: "unset" }}
                      aria-label="whatsapp"
                    >
                      <i
                        className="fab fa-whatsapp mx-2"
                        style={{ fontSize: 25 }}
                      ></i>
                    </a>
                    <span
                      style={{
                        background: "#d6d6d6",
                        padding: " 3px 15px",
                        color: "#444",
                        borderRadius: "8px",
                        fontSize: 12,
                      }}
                    >
                      {ToDateJalali(state.data.data.created_at)}
                    </span> */}
                    </div>
                  </header>
                  <div className="blog-image mb-3">
                    <img
                      src={
                        Array.isArray(
                          state && state.data && state.data.data.images
                        )
                          ? state.data.data.images[0]
                          : window.origin +
                          "/WebSide/assets/images/biabanian/G1.jpg"
                      }
                      alt={renderAlt(state.data.data)}
                      className="object-fit-cover rounded-15 img-fluid"
                    />
                  </div>
                  <BlogContent loading={state.loading} data={state.data} />
                </div>
                <BoxShadow className={"my-4"}>
                  <Comments isApp={isApp}
                    rel={"Blog"}
                    id={state && state.data.data && state.data.data.id}
                    comments={state && state.data && state.data.Comments}
                  />
                </BoxShadow>
              </div>
            )}
          </div>
          {!isApp && <Mobile2 />}
        </div>

        <RenderBasket basket={basket} />
      </section >
    </>
  );
}

export default Single;
